import React from "react";
import LegalDoc from "../components/LegalDoc";

export default function Cookies() {
  return <LegalDoc docKey="cookies" />;
}
